import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getSentryConfig } from './get-sentry-config';
import { sentryClient, setSentryClient } from './sentry-client';
var DISABLED_INTEGRATIONS = ['onerror', 'onunhandledrejection',
// In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
'Dedupe'];
export function initialiseSentry(_x, _x2) {
  return _initialiseSentry.apply(this, arguments);
}
function _initialiseSentry() {
  _initialiseSentry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, options) {
    var sentryConfig;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!sentryClient) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          if (client) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          setSentryClient(client);
          sentryConfig = getSentryConfig(options);
          sentryClient.init(_objectSpread(_objectSpread({}, sentryConfig), {}, {
            integrations: function integrations(_integrations) {
              return _integrations.filter(function (integration) {
                return DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
              });
            }
          }));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _initialiseSentry.apply(this, arguments);
}